module.exports = __webpack_public_path__ + "img/icon_det.48d0bdfb.png";